import { Stack } from "@mui/material";
import { Orders, Positions } from "./widgets";
import { useState } from "react";

export function PositionsAndOrders() {
    const [isPositionsExpanded, setIsPositionsExpanded] = useState<boolean>(false);
    const [isOrdersExpanded, setIsOrdersExpanded] = useState<boolean>(false);
    
    return(
        <Stack
            direction="column"
            sx={{
                height: '100%',
                overflow: 'hidden',
            }}
        >
            {isOrdersExpanded
                ? null
                : <Positions
                      isExpanded={isPositionsExpanded}
                      setIsExpanded={setIsPositionsExpanded}
                  />}
            {isPositionsExpanded
                ? null
                : <Orders
                      isExpanded={isOrdersExpanded}
                      setIsExpanded={setIsOrdersExpanded}
                  />}
        </Stack>
    )
}